import { cldThumb } from '../utils/img';

// The designs a parent picked on skipzy.com/book-v2 (appointment.selected_designs, resolved by the
// backend: services/selected_designs.py). A pick is one in-stock unit's zoddle barcode, which also
// names the size. Shown to ops and the packer as information; nothing packs
// them automatically. An unknown code or a sold-out piece is shown as such, never hidden.

const STATUS = {
  available: { label: 'In stock', cls: 'bg-green-50 text-green-700 ring-green-200' },
  sold_out: { label: 'Sold out', cls: 'bg-amber-50 text-amber-800 ring-amber-200' },
  unknown: { label: 'Code not found', cls: 'bg-pink-50 text-pink-700 ring-pink-200' },
};

// Picks in a size none of the booking's children wear (the website lets a parent pick any size in stock).
export const differentSize = (designs, childSizes) =>
  (designs || []).filter(d => d.size && childSizes.length && !childSizes.includes(d.size));

export default function SelectedDesigns({ designs, compact = false, childSizes = [] }) {
  if (!designs || designs.length === 0) return null;
  const groups = designs.reduce((m, d) => {
    (m[d.garment || 'Other'] = m[d.garment || 'Other'] || []).push(d);
    return m;
  }, {});
  return (
    <div>
      {Object.entries(groups).map(([garment, list]) => (
        <div key={garment} className={compact ? 'mb-1.5' : 'mb-3'}>
          <p className="text-[11px] font-semibold text-gray-500 mb-1">{garment}</p>
          <ul className="flex flex-wrap gap-2">
            {list.map((d) => {
              const s = STATUS[d.status] || STATUS.unknown;
              return (
                <li key={`${garment}-${d.zoddle_barcode || d.code}`}
                  title={d.name ? `${d.brand} · ${d.name}` : `Nothing found for ${d.zoddle_barcode || d.code}`}
                  className={`flex items-center gap-2 rounded-lg border border-gray-200 bg-white ${compact ? 'p-1 pr-2' : 'p-1.5 pr-3'}`}>
                  {d.image_url
                    ? <img src={cldThumb(d.image_url, 120)} alt="" loading="lazy" className={`${compact ? 'h-9 w-9' : 'h-12 w-12'} rounded object-cover bg-gray-100`} />
                    : <div className={`${compact ? 'h-9 w-9' : 'h-12 w-12'} rounded bg-gray-100`} aria-hidden />}
                  <div className="min-w-0">
                    <p className="text-[12px] font-medium text-gray-900 truncate max-w-[10rem]">{d.brand || 'Unknown'}</p>
                    <p className="text-[11px] text-gray-500">
                      <span className="font-mono">#{d.code}</span>
                      {d.size && <span> · {d.size}</span>}
                      {d.zoddle_barcode && <span className="font-mono text-gray-400"> · {d.zoddle_barcode}</span>}
                    </p>
                  </div>
                  <span className={`inline-flex items-center h-5 px-1.5 rounded text-[10.5px] font-medium ring-1 ring-inset whitespace-nowrap ${s.cls}`}>{s.label}</span>
                  {d.size && childSizes.length > 0 && !childSizes.includes(d.size) && (
                    <span className="inline-flex items-center h-5 px-1.5 rounded text-[10.5px] font-semibold ring-1 ring-inset whitespace-nowrap bg-red-50 text-red-700 ring-red-200">Different size · child is {childSizes.join('/')}</span>
                  )}
                </li>
              );
            })}
          </ul>
        </div>
      ))}
    </div>
  );
}
